import createPalette from '@mui/material/styles/createPalette';
import colors from '../colors';
import neutrals from '../neutrals';
import shades from '../shades';
const palette = createPalette({
    primary: { main: shades.black },
    secondary: { main: shades.black },
    success: {
        light: colors.teal.light,
        main: colors.teal.dark,
        dark: '',
        contrastText: shades.white,
    },
    error: {
        light: colors.pink.light,
        main: colors.pink.dark,
        dark: '',
        contrastText: shades.white,
    },
    text: {
        primary: shades.black,
        secondary: neutrals[600],
        disabled: neutrals[500],
    },
    background: {
        default: shades.white,
        paper: shades.white,
    },
});
export default palette;
//# sourceMappingURL=palette.js.map